// extracted by mini-css-extract-plugin
export var statItem = "_ku-1";
export var statsRow = "_ku-0";